import PrimaryPalette from '../../colors';
import type { Color } from '../../colors';

export type StatusIndicatorThemeType = {
  dotColor: Color,
  darkTextColor: Color,
  lightTextColor: Color,
};

type StatusIndicatorThemeSet = {
  OPEN: StatusIndicatorThemeType,
  CLOSED: StatusIndicatorThemeType,
  DRAFT: StatusIndicatorThemeType,
  COMPLETED: StatusIndicatorThemeType,
  OFF: StatusIndicatorThemeType,
  DISABLED: StatusIndicatorThemeType,
};

const StatusIndicatorTheme: StatusIndicatorThemeSet = {
  OPEN: {
    dotColor: PrimaryPalette.mediumGreen,
    darkTextColor: PrimaryPalette.mediumEvergreen,
    lightTextColor: PrimaryPalette.white,
  },
  CLOSED: {
    dotColor: PrimaryPalette.mediumPoppy,
    darkTextColor: PrimaryPalette.mediumEvergreen,
    lightTextColor: PrimaryPalette.white,
  },
  DRAFT: {
    dotColor: PrimaryPalette.darkYellow,
    darkTextColor: PrimaryPalette.mediumEvergreen,
    lightTextColor: PrimaryPalette.white,
  },
  COMPLETED: {
    dotColor: PrimaryPalette.lightIris,
    darkTextColor: PrimaryPalette.mediumEvergreen,
    lightTextColor: PrimaryPalette.white,
  },
  OFF: {
    dotColor: PrimaryPalette.darkGrey,
    darkTextColor: PrimaryPalette.mediumEvergreen,
    lightTextColor: PrimaryPalette.white,
  },
  DISABLED: {
    dotColor: PrimaryPalette.darkerGrey,
    darkTextColor: PrimaryPalette.darkerGrey,
    lightTextColor: PrimaryPalette.white,
  },
};

export { StatusIndicatorTheme };
